import { default as categories1LohWkXD0OMeta } from "/tmp/8dd994b3f105a80/pages/admin/cms/categories.vue?macro=true";
import { default as indexxfLjVWC2H7Meta } from "/tmp/8dd994b3f105a80/pages/admin/enrolment/closeYear/index.vue?macro=true";
import { default as index6X2nmqMlMeMeta } from "/tmp/8dd994b3f105a80/pages/admin/enrolment/list/index.vue?macro=true";
import { default as indexwWfC1v2tJeMeta } from "/tmp/8dd994b3f105a80/pages/admin/enrolment/process/index.vue?macro=true";
import { default as registerpM63D0ktijMeta } from "/tmp/8dd994b3f105a80/pages/admin/enrolment/register.vue?macro=true";
import { default as list0hNWPj1YsjMeta } from "/tmp/8dd994b3f105a80/pages/admin/finance/list.vue?macro=true";
import { default as paymentsURr2pC3caEMeta } from "/tmp/8dd994b3f105a80/pages/admin/finance/payments.vue?macro=true";
import { default as borrowReJDPAwipRMeta } from "/tmp/8dd994b3f105a80/pages/admin/library/borrow.vue?macro=true";
import { default as homefkjWkLQ1TwMeta } from "/tmp/8dd994b3f105a80/pages/admin/library/home.vue?macro=true";
import { default as loansgujZ9KT4hwMeta } from "/tmp/8dd994b3f105a80/pages/admin/library/loans.vue?macro=true";
import { default as searchertroQSOqJ57Meta } from "/tmp/8dd994b3f105a80/pages/admin/library/searcher.vue?macro=true";
import { default as managereKAypRc55wMeta } from "/tmp/8dd994b3f105a80/pages/admin/mgsystems/manager.vue?macro=true";
import { default as indexPWpgo57mpVMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/cohort/index.vue?macro=true";
import { default as indexAnGnz4dfVDMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/curriculum/index.vue?macro=true";
import { default as indexeJpvYvvC4kMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/dua/index.vue?macro=true";
import { default as indexAveeqDyhRmMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/evaluationSystems/index.vue?macro=true";
import { default as index64DDmJQcNBMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/lnut/index.vue?macro=true";
import { default as indexLuMjTgRWIvMeta } from "/tmp/8dd994b3f105a80/pages/admin/school/rooms/index.vue?macro=true";
import { default as indexTlHbX7l6PoMeta } from "/tmp/8dd994b3f105a80/pages/admin/system/config/index.vue?macro=true";
import { default as index47XtR7YtRkMeta } from "/tmp/8dd994b3f105a80/pages/admin/system/profile/index.vue?macro=true";
import { default as indexFe6uKV54MfMeta } from "/tmp/8dd994b3f105a80/pages/admin/system/roles/index.vue?macro=true";
import { default as indexXsjgR3lsEBMeta } from "/tmp/8dd994b3f105a80/pages/admin/system/simpleEnrolments/index.vue?macro=true";
import { default as admisiones1wXf09G6tGMeta } from "/tmp/8dd994b3f105a80/pages/admisiones.vue?macro=true";
import { default as indexfyQbmEgsRwMeta } from "/tmp/8dd994b3f105a80/pages/agenda/index.vue?macro=true";
import { default as chatJGDINw9m9jMeta } from "/tmp/8dd994b3f105a80/pages/chat.vue?macro=true";
import { default as _91_46_46_46slug_93fsyHqogNTXMeta } from "/tmp/8dd994b3f105a80/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue?macro=true";
import { default as _91slug_93vIoc8JrUCxMeta } from "/tmp/8dd994b3f105a80/pages/circulares/[category]/[slug].vue?macro=true";
import { default as indexdfkEMCTSkFMeta } from "/tmp/8dd994b3f105a80/pages/circulares/[category]/index.vue?macro=true";
import { default as indexqZc9eKHVgmMeta } from "/tmp/8dd994b3f105a80/pages/circulares/index.vue?macro=true";
import { default as _91slug_93spZ3fruTaFMeta } from "/tmp/8dd994b3f105a80/pages/cms/[category]/[slug].vue?macro=true";
import { default as indexSHBQGDx20nMeta } from "/tmp/8dd994b3f105a80/pages/cms/[category]/index.vue?macro=true";
import { default as _91id_93kSkrvt2EE6Meta } from "/tmp/8dd994b3f105a80/pages/cms/banner/[id].vue?macro=true";
import { default as _91id_93tIxO4T5MQWMeta } from "/tmp/8dd994b3f105a80/pages/cms/home/[id].vue?macro=true";
import { default as contactoFMKPa21lGDMeta } from "/tmp/8dd994b3f105a80/pages/contacto.vue?macro=true";
import { default as mykPGmZT2AD4Meta } from "/tmp/8dd994b3f105a80/pages/finance/my.vue?macro=true";
import { default as forgotPassword5ablMOoOVyMeta } from "/tmp/8dd994b3f105a80/pages/forgotPassword.vue?macro=true";
import { default as listUbAYaG59EHMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/employees/list.vue?macro=true";
import { default as eppsDpwVfXWJ4vMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/epps.vue?macro=true";
import { default as examszCwIMC34gkMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/exams.vue?macro=true";
import { default as jobsjG6R4jm7FXMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/jobs.vue?macro=true";
import { default as managermXFYTFkAWBMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/risk/manager.vue?macro=true";
import { default as risksA4ELBFMf2TMeta } from "/tmp/8dd994b3f105a80/pages/hhrr/risk/risks.vue?macro=true";
import { default as homenTqQsODMPvMeta } from "/tmp/8dd994b3f105a80/pages/home.vue?macro=true";
import { default as myVFiR00KH9aMeta } from "/tmp/8dd994b3f105a80/pages/incidents/my.vue?macro=true";
import { default as indext5JfxqrImKMeta } from "/tmp/8dd994b3f105a80/pages/index.vue?macro=true";
import { default as linksEGK004pGrlMeta } from "/tmp/8dd994b3f105a80/pages/links.vue?macro=true";
import { default as _91_91tab_93_93wNNPGEpKH2Meta } from "/tmp/8dd994b3f105a80/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue?macro=true";
import { default as _91tab_93IZgp7wfhKTMeta } from "/tmp/8dd994b3f105a80/pages/lnut/home/subject/[id]/[tab].vue?macro=true";
import { default as loginqDMBG6zPo9Meta } from "/tmp/8dd994b3f105a80/pages/login.vue?macro=true";
import { default as logout0lsixFjbeUMeta } from "/tmp/8dd994b3f105a80/pages/logout.vue?macro=true";
import { default as noticiasQz0sOy8jINMeta } from "/tmp/8dd994b3f105a80/pages/noticias.vue?macro=true";
import { default as _91tab_93S5uy15aymXMeta } from "/tmp/8dd994b3f105a80/pages/profile/settings/[tab].vue?macro=true";
import { default as _91token_93zCkL2vhqlJMeta } from "/tmp/8dd994b3f105a80/pages/resetPassword/[token].vue?macro=true";
import { default as licenciae2Cf4w5eRoMeta } from "/tmp/8dd994b3f105a80/pages/rules/licencia.vue?macro=true";
import { default as manual483p8yUCmLMeta } from "/tmp/8dd994b3f105a80/pages/rules/manual.vue?macro=true";
import { default as politicasddKyASFMLrMeta } from "/tmp/8dd994b3f105a80/pages/rules/politicas.vue?macro=true";
import { default as terminospcnCNEgdxhMeta } from "/tmp/8dd994b3f105a80/pages/rules/terminos.vue?macro=true";
import { default as myEeahGu39WWMeta } from "/tmp/8dd994b3f105a80/pages/schedule/my.vue?macro=true";
import { default as index3cpzOrEfGSMeta } from "/tmp/8dd994b3f105a80/pages/school/assistance/entrance/index.vue?macro=true";
import { default as indexcs5CHqBzqIMeta } from "/tmp/8dd994b3f105a80/pages/school/assistance/report/index.vue?macro=true";
import { default as indexfaiLKGrquqMeta } from "/tmp/8dd994b3f105a80/pages/school/sico/index.vue?macro=true";
import { default as adminpiaraPkO6SWH6lMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/adminpiar.vue?macro=true";
import { default as characterizationocOXs9ylQSMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/characterization.vue?macro=true";
import { default as coursesOFDuII4LwxMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/courses.vue?macro=true";
import { default as lowPerformance1S5BNAtzadMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/lowPerformance.vue?macro=true";
import { default as performancea7wRgqe1DvMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/performance.vue?macro=true";
import { default as resourcesVEhsVzVJVTMeta } from "/tmp/8dd994b3f105a80/pages/school/tracing/resources.vue?macro=true";
import { default as indexizKd5GWFBOMeta } from "/tmp/8dd994b3f105a80/pages/school/transport/index.vue?macro=true";
import { default as _91_46_46_46slug_93S5eWRgLd9ZMeta } from "/tmp/8dd994b3f105a80/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue?macro=true";
import { default as testdBKNjDwrm1Meta } from "/tmp/8dd994b3f105a80/pages/test.vue?macro=true";
export default [
  {
    name: categories1LohWkXD0OMeta?.name ?? "admin-cms-categories",
    path: categories1LohWkXD0OMeta?.path ?? "/admin/cms/categories",
    meta: categories1LohWkXD0OMeta || {},
    alias: categories1LohWkXD0OMeta?.alias || [],
    redirect: categories1LohWkXD0OMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/cms/categories.vue").then(m => m.default || m)
  },
  {
    name: indexxfLjVWC2H7Meta?.name ?? "admin-enrolment-closeYear",
    path: indexxfLjVWC2H7Meta?.path ?? "/admin/enrolment/closeYear",
    meta: indexxfLjVWC2H7Meta || {},
    alias: indexxfLjVWC2H7Meta?.alias || [],
    redirect: indexxfLjVWC2H7Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/enrolment/closeYear/index.vue").then(m => m.default || m)
  },
  {
    name: index6X2nmqMlMeMeta?.name ?? "admin-enrolment-list",
    path: index6X2nmqMlMeMeta?.path ?? "/admin/enrolment/list",
    meta: index6X2nmqMlMeMeta || {},
    alias: index6X2nmqMlMeMeta?.alias || [],
    redirect: index6X2nmqMlMeMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/enrolment/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexwWfC1v2tJeMeta?.name ?? "admin-enrolment-process",
    path: indexwWfC1v2tJeMeta?.path ?? "/admin/enrolment/process",
    meta: indexwWfC1v2tJeMeta || {},
    alias: indexwWfC1v2tJeMeta?.alias || [],
    redirect: indexwWfC1v2tJeMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/enrolment/process/index.vue").then(m => m.default || m)
  },
  {
    name: registerpM63D0ktijMeta?.name ?? "admin-enrolment-register",
    path: registerpM63D0ktijMeta?.path ?? "/admin/enrolment/register",
    meta: registerpM63D0ktijMeta || {},
    alias: registerpM63D0ktijMeta?.alias || [],
    redirect: registerpM63D0ktijMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/enrolment/register.vue").then(m => m.default || m)
  },
  {
    name: list0hNWPj1YsjMeta?.name ?? "admin-finance-list",
    path: list0hNWPj1YsjMeta?.path ?? "/admin/finance/list",
    meta: list0hNWPj1YsjMeta || {},
    alias: list0hNWPj1YsjMeta?.alias || [],
    redirect: list0hNWPj1YsjMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/finance/list.vue").then(m => m.default || m)
  },
  {
    name: paymentsURr2pC3caEMeta?.name ?? "admin-finance-payments",
    path: paymentsURr2pC3caEMeta?.path ?? "/admin/finance/payments",
    meta: paymentsURr2pC3caEMeta || {},
    alias: paymentsURr2pC3caEMeta?.alias || [],
    redirect: paymentsURr2pC3caEMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/finance/payments.vue").then(m => m.default || m)
  },
  {
    name: borrowReJDPAwipRMeta?.name ?? "admin-library-borrow",
    path: borrowReJDPAwipRMeta?.path ?? "/admin/library/borrow",
    meta: borrowReJDPAwipRMeta || {},
    alias: borrowReJDPAwipRMeta?.alias || [],
    redirect: borrowReJDPAwipRMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/library/borrow.vue").then(m => m.default || m)
  },
  {
    name: homefkjWkLQ1TwMeta?.name ?? "admin-library-home",
    path: homefkjWkLQ1TwMeta?.path ?? "/admin/library/home",
    meta: homefkjWkLQ1TwMeta || {},
    alias: homefkjWkLQ1TwMeta?.alias || [],
    redirect: homefkjWkLQ1TwMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/library/home.vue").then(m => m.default || m)
  },
  {
    name: loansgujZ9KT4hwMeta?.name ?? "admin-library-loans",
    path: loansgujZ9KT4hwMeta?.path ?? "/admin/library/loans",
    meta: loansgujZ9KT4hwMeta || {},
    alias: loansgujZ9KT4hwMeta?.alias || [],
    redirect: loansgujZ9KT4hwMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/library/loans.vue").then(m => m.default || m)
  },
  {
    name: searchertroQSOqJ57Meta?.name ?? "admin-library-searcher",
    path: searchertroQSOqJ57Meta?.path ?? "/admin/library/searcher",
    meta: searchertroQSOqJ57Meta || {},
    alias: searchertroQSOqJ57Meta?.alias || [],
    redirect: searchertroQSOqJ57Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/library/searcher.vue").then(m => m.default || m)
  },
  {
    name: managereKAypRc55wMeta?.name ?? "admin-mgsystems-manager",
    path: managereKAypRc55wMeta?.path ?? "/admin/mgsystems/manager",
    meta: managereKAypRc55wMeta || {},
    alias: managereKAypRc55wMeta?.alias || [],
    redirect: managereKAypRc55wMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/mgsystems/manager.vue").then(m => m.default || m)
  },
  {
    name: indexPWpgo57mpVMeta?.name ?? "admin-school-cohort",
    path: indexPWpgo57mpVMeta?.path ?? "/admin/school/cohort",
    meta: indexPWpgo57mpVMeta || {},
    alias: indexPWpgo57mpVMeta?.alias || [],
    redirect: indexPWpgo57mpVMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/cohort/index.vue").then(m => m.default || m)
  },
  {
    name: indexAnGnz4dfVDMeta?.name ?? "admin-school-curriculum",
    path: indexAnGnz4dfVDMeta?.path ?? "/admin/school/curriculum",
    meta: indexAnGnz4dfVDMeta || {},
    alias: indexAnGnz4dfVDMeta?.alias || [],
    redirect: indexAnGnz4dfVDMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/curriculum/index.vue").then(m => m.default || m)
  },
  {
    name: indexeJpvYvvC4kMeta?.name ?? "admin-school-dua",
    path: indexeJpvYvvC4kMeta?.path ?? "/admin/school/dua",
    meta: indexeJpvYvvC4kMeta || {},
    alias: indexeJpvYvvC4kMeta?.alias || [],
    redirect: indexeJpvYvvC4kMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/dua/index.vue").then(m => m.default || m)
  },
  {
    name: indexAveeqDyhRmMeta?.name ?? "admin-school-evaluationSystems",
    path: indexAveeqDyhRmMeta?.path ?? "/admin/school/evaluationSystems",
    meta: indexAveeqDyhRmMeta || {},
    alias: indexAveeqDyhRmMeta?.alias || [],
    redirect: indexAveeqDyhRmMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/evaluationSystems/index.vue").then(m => m.default || m)
  },
  {
    name: index64DDmJQcNBMeta?.name ?? "admin-school-lnut",
    path: index64DDmJQcNBMeta?.path ?? "/admin/school/lnut",
    meta: index64DDmJQcNBMeta || {},
    alias: index64DDmJQcNBMeta?.alias || [],
    redirect: index64DDmJQcNBMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/lnut/index.vue").then(m => m.default || m)
  },
  {
    name: indexLuMjTgRWIvMeta?.name ?? "admin-school-rooms",
    path: indexLuMjTgRWIvMeta?.path ?? "/admin/school/rooms",
    meta: indexLuMjTgRWIvMeta || {},
    alias: indexLuMjTgRWIvMeta?.alias || [],
    redirect: indexLuMjTgRWIvMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/school/rooms/index.vue").then(m => m.default || m)
  },
  {
    name: indexTlHbX7l6PoMeta?.name ?? "admin-system-config",
    path: indexTlHbX7l6PoMeta?.path ?? "/admin/system/config",
    meta: indexTlHbX7l6PoMeta || {},
    alias: indexTlHbX7l6PoMeta?.alias || [],
    redirect: indexTlHbX7l6PoMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/system/config/index.vue").then(m => m.default || m)
  },
  {
    name: index47XtR7YtRkMeta?.name ?? "admin-system-profile",
    path: index47XtR7YtRkMeta?.path ?? "/admin/system/profile",
    meta: index47XtR7YtRkMeta || {},
    alias: index47XtR7YtRkMeta?.alias || [],
    redirect: index47XtR7YtRkMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/system/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexFe6uKV54MfMeta?.name ?? "admin-system-roles",
    path: indexFe6uKV54MfMeta?.path ?? "/admin/system/roles",
    meta: indexFe6uKV54MfMeta || {},
    alias: indexFe6uKV54MfMeta?.alias || [],
    redirect: indexFe6uKV54MfMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/system/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexXsjgR3lsEBMeta?.name ?? "admin-system-simpleEnrolments",
    path: indexXsjgR3lsEBMeta?.path ?? "/admin/system/simpleEnrolments",
    meta: indexXsjgR3lsEBMeta || {},
    alias: indexXsjgR3lsEBMeta?.alias || [],
    redirect: indexXsjgR3lsEBMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admin/system/simpleEnrolments/index.vue").then(m => m.default || m)
  },
  {
    name: admisiones1wXf09G6tGMeta?.name ?? "admisiones",
    path: admisiones1wXf09G6tGMeta?.path ?? "/admisiones",
    meta: admisiones1wXf09G6tGMeta || {},
    alias: admisiones1wXf09G6tGMeta?.alias || [],
    redirect: admisiones1wXf09G6tGMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/admisiones.vue").then(m => m.default || m)
  },
  {
    name: indexfyQbmEgsRwMeta?.name ?? "agenda",
    path: indexfyQbmEgsRwMeta?.path ?? "/agenda",
    meta: indexfyQbmEgsRwMeta || {},
    alias: indexfyQbmEgsRwMeta?.alias || [],
    redirect: indexfyQbmEgsRwMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/agenda/index.vue").then(m => m.default || m)
  },
  {
    name: chatJGDINw9m9jMeta?.name ?? "chat",
    path: chatJGDINw9m9jMeta?.path ?? "/chat",
    meta: chatJGDINw9m9jMeta || {},
    alias: chatJGDINw9m9jMeta?.alias || [],
    redirect: chatJGDINw9m9jMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93fsyHqogNTXMeta?.name ?? "cicle-home-id-subject-tab-subid-slug",
    path: _91_46_46_46slug_93fsyHqogNTXMeta?.path ?? "/cicle/home/:id()/:subject()/:tab?/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_93fsyHqogNTXMeta || {},
    alias: _91_46_46_46slug_93fsyHqogNTXMeta?.alias || [],
    redirect: _91_46_46_46slug_93fsyHqogNTXMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93vIoc8JrUCxMeta?.name ?? "circulares-category-slug",
    path: _91slug_93vIoc8JrUCxMeta?.path ?? "/circulares/:category()/:slug()",
    meta: _91slug_93vIoc8JrUCxMeta || {},
    alias: _91slug_93vIoc8JrUCxMeta?.alias || [],
    redirect: _91slug_93vIoc8JrUCxMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/circulares/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexdfkEMCTSkFMeta?.name ?? "circulares-category",
    path: indexdfkEMCTSkFMeta?.path ?? "/circulares/:category()",
    meta: indexdfkEMCTSkFMeta || {},
    alias: indexdfkEMCTSkFMeta?.alias || [],
    redirect: indexdfkEMCTSkFMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/circulares/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexqZc9eKHVgmMeta?.name ?? "circulares",
    path: indexqZc9eKHVgmMeta?.path ?? "/circulares",
    meta: indexqZc9eKHVgmMeta || {},
    alias: indexqZc9eKHVgmMeta?.alias || [],
    redirect: indexqZc9eKHVgmMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/circulares/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93spZ3fruTaFMeta?.name ?? "cms-category-slug",
    path: _91slug_93spZ3fruTaFMeta?.path ?? "/cms/:category()/:slug()",
    meta: _91slug_93spZ3fruTaFMeta || {},
    alias: _91slug_93spZ3fruTaFMeta?.alias || [],
    redirect: _91slug_93spZ3fruTaFMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/cms/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSHBQGDx20nMeta?.name ?? "cms-category",
    path: indexSHBQGDx20nMeta?.path ?? "/cms/:category()",
    meta: indexSHBQGDx20nMeta || {},
    alias: indexSHBQGDx20nMeta?.alias || [],
    redirect: indexSHBQGDx20nMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/cms/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93kSkrvt2EE6Meta?.name ?? "cms-banner-id",
    path: _91id_93kSkrvt2EE6Meta?.path ?? "/cms/banner/:id()",
    meta: _91id_93kSkrvt2EE6Meta || {},
    alias: _91id_93kSkrvt2EE6Meta?.alias || [],
    redirect: _91id_93kSkrvt2EE6Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/cms/banner/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93tIxO4T5MQWMeta?.name ?? "cms-home-id",
    path: _91id_93tIxO4T5MQWMeta?.path ?? "/cms/home/:id()",
    meta: _91id_93tIxO4T5MQWMeta || {},
    alias: _91id_93tIxO4T5MQWMeta?.alias || [],
    redirect: _91id_93tIxO4T5MQWMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/cms/home/[id].vue").then(m => m.default || m)
  },
  {
    name: contactoFMKPa21lGDMeta?.name ?? "contacto",
    path: contactoFMKPa21lGDMeta?.path ?? "/contacto",
    meta: contactoFMKPa21lGDMeta || {},
    alias: contactoFMKPa21lGDMeta?.alias || [],
    redirect: contactoFMKPa21lGDMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/contacto.vue").then(m => m.default || m)
  },
  {
    name: mykPGmZT2AD4Meta?.name ?? "finance-my",
    path: mykPGmZT2AD4Meta?.path ?? "/finance/my",
    meta: mykPGmZT2AD4Meta || {},
    alias: mykPGmZT2AD4Meta?.alias || [],
    redirect: mykPGmZT2AD4Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/finance/my.vue").then(m => m.default || m)
  },
  {
    name: forgotPassword5ablMOoOVyMeta?.name ?? "forgotPassword",
    path: forgotPassword5ablMOoOVyMeta?.path ?? "/forgotPassword",
    meta: forgotPassword5ablMOoOVyMeta || {},
    alias: forgotPassword5ablMOoOVyMeta?.alias || [],
    redirect: forgotPassword5ablMOoOVyMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/forgotPassword.vue").then(m => m.default || m)
  },
  {
    name: listUbAYaG59EHMeta?.name ?? "hhrr-employees-list",
    path: listUbAYaG59EHMeta?.path ?? "/hhrr/employees/list",
    meta: listUbAYaG59EHMeta || {},
    alias: listUbAYaG59EHMeta?.alias || [],
    redirect: listUbAYaG59EHMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/employees/list.vue").then(m => m.default || m)
  },
  {
    name: eppsDpwVfXWJ4vMeta?.name ?? "hhrr-profesiogram-epps",
    path: eppsDpwVfXWJ4vMeta?.path ?? "/hhrr/profesiogram/epps",
    meta: eppsDpwVfXWJ4vMeta || {},
    alias: eppsDpwVfXWJ4vMeta?.alias || [],
    redirect: eppsDpwVfXWJ4vMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/epps.vue").then(m => m.default || m)
  },
  {
    name: examszCwIMC34gkMeta?.name ?? "hhrr-profesiogram-exams",
    path: examszCwIMC34gkMeta?.path ?? "/hhrr/profesiogram/exams",
    meta: examszCwIMC34gkMeta || {},
    alias: examszCwIMC34gkMeta?.alias || [],
    redirect: examszCwIMC34gkMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/exams.vue").then(m => m.default || m)
  },
  {
    name: jobsjG6R4jm7FXMeta?.name ?? "hhrr-profesiogram-jobs",
    path: jobsjG6R4jm7FXMeta?.path ?? "/hhrr/profesiogram/jobs",
    meta: jobsjG6R4jm7FXMeta || {},
    alias: jobsjG6R4jm7FXMeta?.alias || [],
    redirect: jobsjG6R4jm7FXMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/profesiogram/jobs.vue").then(m => m.default || m)
  },
  {
    name: managermXFYTFkAWBMeta?.name ?? "hhrr-risk-manager",
    path: managermXFYTFkAWBMeta?.path ?? "/hhrr/risk/manager",
    meta: managermXFYTFkAWBMeta || {},
    alias: managermXFYTFkAWBMeta?.alias || [],
    redirect: managermXFYTFkAWBMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/risk/manager.vue").then(m => m.default || m)
  },
  {
    name: risksA4ELBFMf2TMeta?.name ?? "hhrr-risk-risks",
    path: risksA4ELBFMf2TMeta?.path ?? "/hhrr/risk/risks",
    meta: risksA4ELBFMf2TMeta || {},
    alias: risksA4ELBFMf2TMeta?.alias || [],
    redirect: risksA4ELBFMf2TMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/hhrr/risk/risks.vue").then(m => m.default || m)
  },
  {
    name: homenTqQsODMPvMeta?.name ?? "home",
    path: homenTqQsODMPvMeta?.path ?? "/home",
    meta: homenTqQsODMPvMeta || {},
    alias: homenTqQsODMPvMeta?.alias || [],
    redirect: homenTqQsODMPvMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/home.vue").then(m => m.default || m)
  },
  {
    name: myVFiR00KH9aMeta?.name ?? "incidents-my",
    path: myVFiR00KH9aMeta?.path ?? "/incidents/my",
    meta: myVFiR00KH9aMeta || {},
    alias: myVFiR00KH9aMeta?.alias || [],
    redirect: myVFiR00KH9aMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/incidents/my.vue").then(m => m.default || m)
  },
  {
    name: indext5JfxqrImKMeta?.name ?? "index",
    path: indext5JfxqrImKMeta?.path ?? "/",
    meta: indext5JfxqrImKMeta || {},
    alias: indext5JfxqrImKMeta?.alias || [],
    redirect: indext5JfxqrImKMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/index.vue").then(m => m.default || m)
  },
  {
    name: linksEGK004pGrlMeta?.name ?? "links",
    path: linksEGK004pGrlMeta?.path ?? "/links",
    meta: linksEGK004pGrlMeta || {},
    alias: linksEGK004pGrlMeta?.alias || [],
    redirect: linksEGK004pGrlMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/links.vue").then(m => m.default || m)
  },
  {
    name: _91_91tab_93_93wNNPGEpKH2Meta?.name ?? "lnut-home-id-section-pk-tab",
    path: _91_91tab_93_93wNNPGEpKH2Meta?.path ?? "/lnut/home/:id()/:section()/:pk?/:tab?",
    meta: _91_91tab_93_93wNNPGEpKH2Meta || {},
    alias: _91_91tab_93_93wNNPGEpKH2Meta?.alias || [],
    redirect: _91_91tab_93_93wNNPGEpKH2Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue").then(m => m.default || m)
  },
  {
    name: _91tab_93IZgp7wfhKTMeta?.name ?? "lnut-home-subject-id-tab",
    path: _91tab_93IZgp7wfhKTMeta?.path ?? "/lnut/home/subject/:id()/:tab()",
    meta: _91tab_93IZgp7wfhKTMeta || {},
    alias: _91tab_93IZgp7wfhKTMeta?.alias || [],
    redirect: _91tab_93IZgp7wfhKTMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/lnut/home/subject/[id]/[tab].vue").then(m => m.default || m)
  },
  {
    name: loginqDMBG6zPo9Meta?.name ?? "login",
    path: loginqDMBG6zPo9Meta?.path ?? "/login",
    meta: loginqDMBG6zPo9Meta || {},
    alias: loginqDMBG6zPo9Meta?.alias || [],
    redirect: loginqDMBG6zPo9Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logout0lsixFjbeUMeta?.name ?? "logout",
    path: logout0lsixFjbeUMeta?.path ?? "/logout",
    meta: logout0lsixFjbeUMeta || {},
    alias: logout0lsixFjbeUMeta?.alias || [],
    redirect: logout0lsixFjbeUMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: noticiasQz0sOy8jINMeta?.name ?? "noticias",
    path: noticiasQz0sOy8jINMeta?.path ?? "/noticias",
    meta: noticiasQz0sOy8jINMeta || {},
    alias: noticiasQz0sOy8jINMeta?.alias || [],
    redirect: noticiasQz0sOy8jINMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/noticias.vue").then(m => m.default || m)
  },
  {
    name: _91tab_93S5uy15aymXMeta?.name ?? "profile-settings-tab",
    path: _91tab_93S5uy15aymXMeta?.path ?? "/profile/settings/:tab()",
    meta: _91tab_93S5uy15aymXMeta || {},
    alias: _91tab_93S5uy15aymXMeta?.alias || [],
    redirect: _91tab_93S5uy15aymXMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/profile/settings/[tab].vue").then(m => m.default || m)
  },
  {
    name: _91token_93zCkL2vhqlJMeta?.name ?? "resetPassword-token",
    path: _91token_93zCkL2vhqlJMeta?.path ?? "/resetPassword/:token()",
    meta: _91token_93zCkL2vhqlJMeta || {},
    alias: _91token_93zCkL2vhqlJMeta?.alias || [],
    redirect: _91token_93zCkL2vhqlJMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/resetPassword/[token].vue").then(m => m.default || m)
  },
  {
    name: licenciae2Cf4w5eRoMeta?.name ?? "rules-licencia",
    path: licenciae2Cf4w5eRoMeta?.path ?? "/rules/licencia",
    meta: licenciae2Cf4w5eRoMeta || {},
    alias: licenciae2Cf4w5eRoMeta?.alias || [],
    redirect: licenciae2Cf4w5eRoMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/rules/licencia.vue").then(m => m.default || m)
  },
  {
    name: manual483p8yUCmLMeta?.name ?? "rules-manual",
    path: manual483p8yUCmLMeta?.path ?? "/rules/manual",
    meta: manual483p8yUCmLMeta || {},
    alias: manual483p8yUCmLMeta?.alias || [],
    redirect: manual483p8yUCmLMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/rules/manual.vue").then(m => m.default || m)
  },
  {
    name: politicasddKyASFMLrMeta?.name ?? "rules-politicas",
    path: politicasddKyASFMLrMeta?.path ?? "/rules/politicas",
    meta: politicasddKyASFMLrMeta || {},
    alias: politicasddKyASFMLrMeta?.alias || [],
    redirect: politicasddKyASFMLrMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/rules/politicas.vue").then(m => m.default || m)
  },
  {
    name: terminospcnCNEgdxhMeta?.name ?? "rules-terminos",
    path: terminospcnCNEgdxhMeta?.path ?? "/rules/terminos",
    meta: terminospcnCNEgdxhMeta || {},
    alias: terminospcnCNEgdxhMeta?.alias || [],
    redirect: terminospcnCNEgdxhMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/rules/terminos.vue").then(m => m.default || m)
  },
  {
    name: myEeahGu39WWMeta?.name ?? "schedule-my",
    path: myEeahGu39WWMeta?.path ?? "/schedule/my",
    meta: myEeahGu39WWMeta || {},
    alias: myEeahGu39WWMeta?.alias || [],
    redirect: myEeahGu39WWMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/schedule/my.vue").then(m => m.default || m)
  },
  {
    name: index3cpzOrEfGSMeta?.name ?? "school-assistance-entrance",
    path: index3cpzOrEfGSMeta?.path ?? "/school/assistance/entrance",
    meta: index3cpzOrEfGSMeta || {},
    alias: index3cpzOrEfGSMeta?.alias || [],
    redirect: index3cpzOrEfGSMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/assistance/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexcs5CHqBzqIMeta?.name ?? "school-assistance-report",
    path: indexcs5CHqBzqIMeta?.path ?? "/school/assistance/report",
    meta: indexcs5CHqBzqIMeta || {},
    alias: indexcs5CHqBzqIMeta?.alias || [],
    redirect: indexcs5CHqBzqIMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/assistance/report/index.vue").then(m => m.default || m)
  },
  {
    name: indexfaiLKGrquqMeta?.name ?? "school-sico",
    path: indexfaiLKGrquqMeta?.path ?? "/school/sico",
    meta: indexfaiLKGrquqMeta || {},
    alias: indexfaiLKGrquqMeta?.alias || [],
    redirect: indexfaiLKGrquqMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/sico/index.vue").then(m => m.default || m)
  },
  {
    name: adminpiaraPkO6SWH6lMeta?.name ?? "school-tracing-adminpiar",
    path: adminpiaraPkO6SWH6lMeta?.path ?? "/school/tracing/adminpiar",
    meta: adminpiaraPkO6SWH6lMeta || {},
    alias: adminpiaraPkO6SWH6lMeta?.alias || [],
    redirect: adminpiaraPkO6SWH6lMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/adminpiar.vue").then(m => m.default || m)
  },
  {
    name: characterizationocOXs9ylQSMeta?.name ?? "school-tracing-characterization",
    path: characterizationocOXs9ylQSMeta?.path ?? "/school/tracing/characterization",
    meta: characterizationocOXs9ylQSMeta || {},
    alias: characterizationocOXs9ylQSMeta?.alias || [],
    redirect: characterizationocOXs9ylQSMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/characterization.vue").then(m => m.default || m)
  },
  {
    name: coursesOFDuII4LwxMeta?.name ?? "school-tracing-courses",
    path: coursesOFDuII4LwxMeta?.path ?? "/school/tracing/courses",
    meta: coursesOFDuII4LwxMeta || {},
    alias: coursesOFDuII4LwxMeta?.alias || [],
    redirect: coursesOFDuII4LwxMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/courses.vue").then(m => m.default || m)
  },
  {
    name: lowPerformance1S5BNAtzadMeta?.name ?? "school-tracing-lowPerformance",
    path: lowPerformance1S5BNAtzadMeta?.path ?? "/school/tracing/lowPerformance",
    meta: lowPerformance1S5BNAtzadMeta || {},
    alias: lowPerformance1S5BNAtzadMeta?.alias || [],
    redirect: lowPerformance1S5BNAtzadMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/lowPerformance.vue").then(m => m.default || m)
  },
  {
    name: performancea7wRgqe1DvMeta?.name ?? "school-tracing-performance",
    path: performancea7wRgqe1DvMeta?.path ?? "/school/tracing/performance",
    meta: performancea7wRgqe1DvMeta || {},
    alias: performancea7wRgqe1DvMeta?.alias || [],
    redirect: performancea7wRgqe1DvMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/performance.vue").then(m => m.default || m)
  },
  {
    name: resourcesVEhsVzVJVTMeta?.name ?? "school-tracing-resources",
    path: resourcesVEhsVzVJVTMeta?.path ?? "/school/tracing/resources",
    meta: resourcesVEhsVzVJVTMeta || {},
    alias: resourcesVEhsVzVJVTMeta?.alias || [],
    redirect: resourcesVEhsVzVJVTMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/tracing/resources.vue").then(m => m.default || m)
  },
  {
    name: indexizKd5GWFBOMeta?.name ?? "school-transport",
    path: indexizKd5GWFBOMeta?.path ?? "/school/transport",
    meta: indexizKd5GWFBOMeta || {},
    alias: indexizKd5GWFBOMeta?.alias || [],
    redirect: indexizKd5GWFBOMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/school/transport/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93S5eWRgLd9ZMeta?.name ?? "subject-home-id-tab-subid-slug",
    path: _91_46_46_46slug_93S5eWRgLd9ZMeta?.path ?? "/subject/home/:id()/:tab()/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_93S5eWRgLd9ZMeta || {},
    alias: _91_46_46_46slug_93S5eWRgLd9ZMeta?.alias || [],
    redirect: _91_46_46_46slug_93S5eWRgLd9ZMeta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: testdBKNjDwrm1Meta?.name ?? "test",
    path: testdBKNjDwrm1Meta?.path ?? "/test",
    meta: testdBKNjDwrm1Meta || {},
    alias: testdBKNjDwrm1Meta?.alias || [],
    redirect: testdBKNjDwrm1Meta?.redirect,
    component: () => import("/tmp/8dd994b3f105a80/pages/test.vue").then(m => m.default || m)
  }
]